import React from 'react';
import { Route, Routes } from 'react-router-dom';

import loadable from '@common/react/loadable/loadableSettings';

import LayoutMain from '@app/components/Layouts/LayoutMain';
import LayoutPrivate from '@app/components/Layouts/LayoutPrivate';
import LayoutWrapper from '@app/components/Layouts/LayoutWrapper';
import ScrollTopAlways from '@app/components/UI/ScrollTop/ScrollTopAlways';

const Home = loadable(() => import(/* webpackChunkName: "HomePage" */ '@app/components/Pages/Home/Home'));
const About = loadable(() => import(/* webpackChunkName: "AboutPage" */ '@app/components/Pages/About/About'));
const UsingPHJ = loadable(() => import(/* webpackChunkName: "UsingPHJPage" */ '@app/components/Pages/UsingPHJ/UsingPHJ'));
const CreateProfile = loadable(() => import(/* webpackChunkName: "CreateProfilePage" */ '@app/components/Pages/CreateProfile/CreateProfile'));
const Profile = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '@app/components/Pages/Profile/Profile'));
const Pets = loadable(() => import(/* webpackChunkName: "PetsPage" */ '@app/components/Pages/Pets/Pets'));
const PetProfile = loadable(() => import(/* webpackChunkName: "PetProfile" */ '@app/components/Pages/Pet/PetProfile'));
const ChangePassword = loadable(() => import(/* webpackChunkName: "ChangePasswordPage" */ '@app/components/Pages/ChangePassword/ChangePassword'));
const ErrorPageContent = loadable(() => import(/* webpackChunkName: "ErrorPageContent" */ '@app/components/UI/ErrorPageContent/ErrorPageContent'));

export const baseRoutes = (
	<>
		<Route element={<LayoutWrapper />}>
			<Route element={<ScrollTopAlways />}>
				<Route element={<LayoutPrivate />}>
					<Route path="/profile" element={<Profile />} />
					<Route path="/pets" element={<Pets />} />
					<Route element={<PetProfile />}>
						<Route path="/pet-profile/:id/:tab" />
					</Route>
					<Route path="/*" element={<ErrorPageContent />} />
				</Route>
				<Route element={<LayoutMain />}>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/using-PHJ" element={<UsingPHJ />} />
					<Route path="/create-profile" element={<CreateProfile />} />
					<Route path="/confirm" element={<ChangePassword />} />
				</Route>
			</Route>
		</Route>
	</>
);

export const routes = (
	<Routes>
		{baseRoutes}
	</Routes>
);
